/* @ngInject */
const myTrainSelectCard = (
  toaster,
  valueHandler,
  $$train,
  labels
) => {
  return {
    restrict: 'E',
    scope: {
      myTrain: '=',
      myLinkedWagonIds: '=',
      isChoose: '=',
    },
    template: require('./myTrainSelectCard.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.isChoose = false

      $scope.selectTrain = async (_train, _selected) => {
        if (_selected) {
          if ($scope.myLinkedWagonIds.length > 0) {
            if (toaster.confirm(labels.wagon.ask.changeTrain)) {
              $scope.myLinkedWagonIds.splice(0, $scope.myLinkedWagonIds.length)
            }
          }
          $scope.isChoose = false
          return
        }

        if (valueHandler.isEmpty(_train.tractionnaire) || valueHandler.isEmpty(_train.date)) {
          return
        }

        _train.arrival = true
        const id = _train.id
        const number = _train.number
        _train.id = null
        _train.number = null
        const trainSearchdata = $$train.format.server(_train)

        try {
          const response = await $$train.request.getByQuickSearch(trainSearchdata)
          const trains = response.trains
          if (trains.length) {
            let train = trains[0]
            _train.id = id || train.id
            _train.number = number
            if (valueHandler.isString(_train.number) && train.number !== _train.number) {
              train = $$train.format.server(_train)
              const response = await $$train.request.update(train)
            }
            _train.id = train.id
            $scope.isChoose = true
            $scope.getWagonOnTrain(_train.id)
          } else {
            const trainCopy = $$train.format.server(_train)
            const response = await $$train.request.save(trainCopy)
            _train.id = response.id
            $scope.isChoose = true
            $scope.getWagonOnTrain(_train.id)
          }
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.getWagonOnTrain = async (_trainId) => {
        try {
          $scope.myTrain.wagons = await $$train.request.getWagons(_trainId)
          if ($scope.myTrain.wagons.length) {
            toaster.message(labels.train.statements.getExisting($scope.myTrain.wagons.length))
          } else {
            toaster.message(labels.train.statements.getNew)
          }
        } catch (error) {
          toaster.error(error)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myTrainSelectCard



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/directives/select/myTrainSelectCard.js